'use strict';
const Modal = require('../modalUtilities');
const navigationCountry = $('.page').attr('data-navigation-country');

if (navigationCountry === 'CN') {
    var TencentCaptcha = require('../common/tencentCaptcha');
}

function updateSuccessPage($selector, data) {
    $selector.empty().html(data.succesPageHtml);
};
function updateListOfStores(data) {
    $('#findStoreStoreSelect').empty().html(data.listOfStoresHtml);
};
function liveChatEnable() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'block',
        visibility: 'visible'
    });
};
function liveChatDisable() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'none',
        visibility: 'hidden'
    });
}

function setButtonAttribute() {
    $('.selectpicker').selectpicker();
    $('.selectpicker').each(function() {
        $(this).css({
            display: 'none'
        });
        var label;
        // set button id for label
        if (this.labels.length > 0) {
            label = this.labels[0].innerText;
        } else {
            label = $(this).closest('.cc-form-group').find('.cc-label').html();
        }
        var $button = $(this).siblings('button');
        // var selectID = $(this).attr('id') + '_btn';
        // var labelID = $(this).attr('id') + '_lbl';
        // $(this).attr('aria-hidden', 'true');
        // $button.attr('id', selectID);
        var $dropdown = $button.siblings('.dropdown-menu').children('.inner');
        $dropdown.attr('aria-label', label);
        $button.attr('aria-label', label);
        $button.attr('role', 'combobox').attr('aria-activedescendant', '');
        $(this).selectpicker('refresh');
        // fix voice over
        $(this).parent().find('.dropdown-toggle').attr('tabindex', '0');
    });
    $('.dropdown-menu .inner').removeAttr('aria-activedescendant');

    var targets = $('button.dropdown-toggle').siblings('.dropdown-menu').children('.inner').removeAttr('aria-activedescendant').get();
    if (targets) {
        // create an observer instance
        targets.forEach(function(target) {
            var observer = new MutationObserver(function(mutations) {
                if (mutations.length) {
                    $(target).removeAttr('aria-activedescendant');
                    // disconnect `observer`
                    // this.disconnect();
                }
            });
            var config = {
                attributes: true
            };

            // pass in the target node, as well as the observer options
            observer.observe(target, config);
        });
    };
    
    // accessibility: fix focus issues with the dropdown select
    $(document).on('keydown', '#js-helpWithSize-modal', (e)=>{
        if (e.key !== 'Tab')  return;
        var $select = $('.selectpicker');
        var $dropdown = $('.dropdown-toggle');
        if ($select.attr('tabindex') === $dropdown.attr('tabindex')) {
            $select.attr('tabindex', '0');
        }
    });
}

function fixLayoutForModalOpen() {
    liveChatDisable();
    $('.cc-product-detail .cc-info-section .cc-info-container, .cc-pdp__info').css('z-index', '10');
}

function fixLayoutForModalClose() {
    $('.cc-product-detail .cc-info-section .cc-info-container, .cc-pdp__info').css('z-index', '3');
    liveChatEnable();
}

function fixLayoutForModalBoutiqueOverlayClose() {
    $('.cc-product-detail .cc-info-section .cc-info-container, .cc-pdp__info').css('z-index', '10');
}

module.exports = {
    openContactUsModal: function() {
        $(document).on('click', '.js-open-contact', function() {
            var m = new Modal('#js-contact-modal', { onShow: fixLayoutForModalOpen, onClose: fixLayoutForModalClose });
            var url = $('.js-open-contact').data('urlcontact');

            let ajaxData = { page: 'PDP-requestInfo' };

            if (navigationCountry === 'CN' && !TencentCaptcha.isAlreadyLoaded()) {
                ajaxData['loadTencentCaptcha'] = true;
            }

            $.ajax({
                url: url,
                method: 'POST',
                data: ajaxData,
                success: function (data) {
                    $('#js-contactUs-product-overlay').html(data);
                    setButtonAttribute();
                    $('#genderSelect option').each(function() {
                        if ($(this).prop('selected') === true && !$(this).hasClass('bs-title-option')) {
                            $('#genderSelect').siblings().find('.filter-option-inner-inner').css('color', '#262626');
                        }
                    });
                    $('#contactSku').val($('.js-open-contact').data('sku'));
                    var $grecaptcha = $('#js-contact-modal .js-captcha-form.lazyloading');
                    if ($grecaptcha.length) {
                        document.body.dispatchEvent(new CustomEvent('grecaptcha-load', {detail: $grecaptcha}));
                    }
                    m.open();
                }
            });
        });
    },

    submitContactUsModal: function() {
        $(document).on('click', '#submitContactUs', function() {
            var url = $('.js-contactus-action').data('action');
            var form = $('#infoProduct');
            var productID = $('#contactSku').val();
            var information = $('#infocategory').val();
            const readyToSubmit = $.Deferred();

            if (navigationCountry === 'CN') {
                // initialize tencent captcha
                var $tencentCaptchaEl = $('.js-tencent-captcha-container', form);
                TencentCaptcha.initialize($tencentCaptchaEl, readyToSubmit);
            } else {
                readyToSubmit.resolve();
            }

            readyToSubmit.done(function() {
                form.spinner().start();
                $.ajax({
                    url: url,
                    method: 'POST',
                    data: form.serialize(),
                    success: function (data) {
                        if (data.success) {
                            // analytics
                            dataLayer.push({
                                event: 'contactUs',
                                eventCategory: 'Contact Us - PDP',
                                eventAction: 'submit_ok',
                                eventLabel: 'product - ' + information,
                                dimension23: productID,
                                dimension24: ''
                            });
                        } else {
                            dataLayer.push({
                                event: 'contactUs',
                                eventCategory: 'Contact Us - PDP',
                                eventAction: 'submit_fail',
                                eventLabel: 'product - ' + information,
                                dimension23: productID,
                                dimension24: ''
                            });
                        }
                        form.spinner().stop();
                        updateSuccessPage($('#infoProduct'), data);
                        // END
                    },
                    error: function (data) {
                        form.spinner().stop();
                        updateSuccessPage($('#infoProduct'), data.responseJSON);
                        // analytics
                        dataLayer.push({
                            event: 'contactUs',
                            eventCategory: 'Contact Us - PDP',
                            eventAction: 'submit_fail',
                            eventLabel: 'product - ' + information,
                            dimension23: productID,
                            dimension24: ''
                        });
                        // END
                    }
                });
            });
        });
    },
    openFindInStoreModal: function() {
        let modalTarget = '#size-boutique-overlay';
        let modal = new Modal(modalTarget, { onShow: fixLayoutForModalOpen, onClose: fixLayoutForModalClose });
        $(document).on('click', '.js-open-findInBoutique', function() {
            var skuMaster = $(this).data('skumaster');
            var color = $(document).find('.js-color-choice.cc-active').data('attr-value');
            var sizeText = $('#js-size-text-selected').hasClass('hidden') ? null : $('#js-size-text-selected').text();
            var label = sizeText !== null ? skuMaster + color + ' - ' + sizeText : skuMaster + color;   // pid concatenation PDP
            if (sizeText !== null) {
                var preselectSize = $(document).find('#size-overlay .cc-size-list .js-select-size.cc-active').data('attr-value');
                $('#js-selected-size-to-find').val(preselectSize);
            }
            var selectedSize = $('#js-selected-size-to-find').val();
            if (selectedSize !== '') {
                $('.js-select-size-to-find').parent('.js-size-container').removeClass('cc-active');
                var sizes = $('.js-select-size-to-find');
                for (var i = 0; i < sizes.length; i++) {
                    if (sizes[i].dataset.attrValue === selectedSize) {
                        sizes[i].parentElement.classList.add('cc-active');
                    }
                }
                $('.js-find-in-store-button').click();
            } else {
                modal.open();
            }
            if (!$('.js-size-not-selected').hasClass('d-none')) {
                $('.js-size-not-selected').addClass('d-none');
            }
            $('body').trigger('analytics:dataLayerPushObj', {
                event: 'custom_event',
                eventCategory: 'Find in Store',
                eventAction: 'Open Layer',
                eventLabel: label
            });
        });

        $(document).on('click', '.js-close-boutique-size', function() {
            modal.close();

        });
    },

    selectSizeFindInStore: function() {
        $(document).on('click', '.js-select-size-to-find', function() {
            var selectedSize = $(this).data('attr-value');
            $('#js-selected-size-to-find').val(selectedSize);
            $('.js-select-size-to-find').parent('.js-size-container').removeClass('cc-active');
            $(this).parent('.js-size-container').addClass('cc-active');
            if(!$('.js-size-not-selected').hasClass('d-none')) {
                $('.js-size-not-selected').addClass('d-none');
            }
            $('.js-find-in-store-button').click();
        });
    },

    searchFindInStore: function() {
        let modalTarget = '#show-boutiques-overlay';
        $(document).on('click', '.js-find-in-store-button', function() {
            if (!$('#size-boutique-overlay').hasClass('cc-open')) {
                var modalClose = fixLayoutForModalClose;
            } else {
                modalClose = fixLayoutForModalBoutiqueOverlayClose;
            }
            let modal = new Modal(modalTarget, { onShow: fixLayoutForModalOpen, onClose: modalClose });
            var selectedSize = $('#js-selected-size-to-find').val();
            if (selectedSize == '') {
                $('.js-size-not-selected').removeClass('d-none');
            } else {
                var skuMaster = $('.js-find-in-store-button').attr('data-skumaster');
                var color = $(document).find('.js-color-choice.cc-active').data('attr-value');
                var sizeText = $('#size-boutique-overlay .js-size-container.cc-active').find('.js-size-value').text();
                var selectedCountry = false;
                if ($('#js-selected-country-for-search').val() != '') {
                    selectedCountry = $('#js-selected-country-for-search').val();
                }
                var sku = skuMaster + color + selectedSize;     // pid concatenation PDP
                var label = skuMaster + color + ' - ' + sizeText;
                var url = $(this).data('url');
                $.spinner().start();
                $.ajax({
                    url: url,
                    method: 'POST',
                    data: {
                        sku: sku,
                        selectedCountry: selectedCountry
                    },
                    success: function (data) {
                        $('#js-show-boutique-overlay').html(data);
                        setButtonAttribute();
                        $('#js-boutique-country option').each(function() {
                            if ($(this).prop('selected') === true && !$(this).hasClass('bs-title-option')) {
                                $('#js-boutique-country').siblings().find('.filter-option-inner-inner').css('color', '#262626');
                            }
                        });
                        modal.open();
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
                $('body').trigger('analytics:dataLayerPushObj', {
                    event: 'custom_event',
                    eventCategory: 'Find in Store',
                    eventAction: 'Size Selected',
                    eventLabel: label
                });
            }
            $('body').on('click', '.js-close-show-boutiques', function(e) {
                e.preventDefault();
                modal.close();
            });
        });

        $(document).on('change', '#js-boutique-country', function() {
            $.spinner().start();
            var countryCode = $('#js-boutique-country').val();
            $('#js-selected-country-for-search').val(countryCode);
            // var url = $('#js-boutique-country').data('url');
            // var sku = $('.js-find-in-store-button').attr('data-sku');
            var skuMaster = $('.js-find-in-store-button').attr('data-skumaster');
            var color = $(document).find('.js-color-choice.cc-active').data('attr-value');
            var sku = skuMaster + color;    // pid concatenation PDP
            var selectedSize = $('#js-selected-size-to-find').val();
            var sizeText = $('#size-boutique-overlay .js-size-container.cc-active').find('.js-size-value').text();
            var label = sku + ' - ' + sizeText;
            sku = sku + selectedSize;
            var url = $(this).data('url');
            $.ajax({
                url: url,
                method: 'POST',
                data: {
                    sku: sku,
                    selectedCountry: countryCode
                },
                success: function (data) {
                    $('#js-show-boutique-overlay').html(data);
                    setButtonAttribute();
                    $('#js-boutique-country option').each(function() {
                        if ($(this).prop('selected') === true && !$(this).hasClass('bs-title-option')) {
                            $('#js-boutique-country').siblings().find('.filter-option-inner-inner').css('color', '#262626');
                        }
                    });
                    $('#js-boutique-country').selectpicker('refresh');
                    dataLayer.push({
                        event: 'custom_event',
                        eventCategory: 'Find in Store',
                        eventAction: 'Change Country',
                        eventLabel: label
                    });
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

    },

    analyticsCallStore: function () {
        $(document).on('click', '.js-analytics-callStore', function() {
            var productId = $(this).data('analyticsku');
            var filterSize = $(this).data('analyticsize');
            var boutiqueId = $(this).data('analyticsbtqid');
            var boutiqueName = $(this).data('analyticsbtqname');
            var label = productId + ' - ' + filterSize;
            var boutique = boutiqueName + ' - ' + boutiqueId;
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Find in Store',
                eventAction: 'Call',
                eventLabel: label,
                boutiqueName: boutique
            });
        });
    },

    analyticsBookAppointment: function () {
        $(document).on('click', '.js-analytics-bookAppointment-PDP', function() {
            var productId = $(this).data('analyticsku');
            var filterSize = $(this).data('analyticsize');
            var boutiqueId = $(this).data('analyticsbtqid');
            var boutiqueName = $(this).data('analyticsbtqname');
            var label = productId + ' - ' + filterSize;
            var boutique = boutiqueName + ' - ' + boutiqueId;
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Find in Store',
                eventAction: 'Boutique Appointment',
                eventLabel: label,
                boutiqueName: boutique
            });
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'exclusive-service',
                eventAction: 'find-in-boutique',
                eventLabel: document.location.href,
                boutiqueName: boutique
            });
        });
    },

    updateListOfStores: function() {
        $(document).on('change', '#findStoreCountrySelect', function() {
            var url = $('#findStoreStoreSelect').data('liststores');
            var countryCode = $('#findStoreCountrySelect').val();
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                data: {
                    countryCode: countryCode,
                    page: 'PDP-FindInStore'
                },
                success: function (data) {
                    $.spinner().stop();
                    updateListOfStores(data);
                    setButtonAttribute();
                    $('.js-select-listOfStores').fadeIn();
                }
            });
        });
    },
    filterListOfStores: function() {
        $(document).on('change', '#filterBoutiqueFind', function() {
            if ($('#filterBoutiqueFind').prop('checked')) {
                $('.js-boutique-no-availability').attr("style", "display: none !important");
            } else $('.js-boutique-no-availability').attr("style", "display: block");
        });
    },
    submitFindInStoreModal: function() {
        $(document).on('click', '#submitFindInStore', function() {
            var url = $('.js-contactus-action').data('action');
            var form = $('#findInStore');
            var productID = $('#findStoreSku').val();
            var selectedNation = $('#findStoreCountrySelect :selected').text();
            var selectedBoutique = $('#findStoreStoreSelect').val();
            selectedBoutique = selectedNation + '-' + selectedBoutique.replace(/ /g, '-');
            form.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: form.serialize(),
                success: function (data) {
                    if (data.success) {
                        // analytics
                        dataLayer.push({
                            event: 'contactUs',
                            eventCategory: 'Contact Us - PDP',
                            eventAction: 'submit_ok',
                            eventLabel: 'product - storesavailability',
                            dimension23: productID,
                            dimension24: selectedBoutique
                        });
                    } else {
                        dataLayer.push({
                            event: 'contactUs',
                            eventCategory: 'Contact Us - PDP',
                            eventAction: 'submit_fail',
                            eventLabel: 'product - storesavailability',
                            dimension23: productID,
                            dimension24: selectedBoutique
                        });
                    }
                    form.spinner().stop();
                    updateSuccessPage($('#findInStore'), data);
                },
                error: function (data) {
                    // analytics
                    dataLayer.push({
                        event: 'contactUs',
                        eventCategory: 'Contact Us - PDP',
                        eventAction: 'submit_fail',
                        eventLabel: 'product - storesavailability',
                        dimension23: productID,
                        dimension24: selectedBoutique
                    });
                    // END
                }
            });
        });
    },
    openHelpWithSizeModal: function() {
        $(document).on('click', '.js-open-helpWhitSize', function() {
            var url = $(this).data('action');
            var sticky = false;
            if (this.id === 'size-help-sticky') {
                sticky = true;
            }
            
            let m;
            if (sticky) {
                m = new Modal('#js-helpWithSize-modal', { onShow: fixLayoutForModalOpen, onClose: fixLayoutForModalClose });
            } else {
                // In this case, in the onClose callback we do not remove the z-index, as the
                // modal was opened from inside another modal
                m = new Modal('#js-helpWithSize-modal', { onShow: fixLayoutForModalOpen, onClose: liveChatEnable });
            }

            let ajaxData = { page: 'PDP-HelpWithSize' };

            if (navigationCountry === 'CN' && !TencentCaptcha.isAlreadyLoaded()) {
                ajaxData['loadTencentCaptcha'] = true;
            }

            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: ajaxData,
                success: function (data) {
                    $.spinner().stop();
                    $('#js-helpWithSize-product-overlay').html(data);
                    $('#helpWithSizeContactSku').val($('.js-open-contact').data('sku'));
                    setButtonAttribute();
                    $('#helpWithSizeGenderSelect option').each(function() {
                        if ($(this).prop('selected') === true && !$(this).hasClass('bs-title-option')) {
                            $('#helpWithSizeGenderSelect').siblings().find('.filter-option-inner-inner').css('color', '#262626');
                        }
                    });
                    $('button[data-id="helpWithSizeGenderSelect"]').attr({
                        'aria-required': 'true',
                        'aria-describedby': 'form-selectgender-error'
                    });
                    var $grecaptcha = $('#js-helpWithSize-product-overlay .js-captcha-form.lazyloading');
                    if ($grecaptcha.length) {
                        document.body.dispatchEvent(new CustomEvent('grecaptcha-load', {detail: $grecaptcha}));
                    }
                    m.open();
                },
                error: function(){
                    $.spinner().stop();
                }
            });
        });
    },

    submitHelpWithSizeModal: function() {
        $(document).on('click', '#helpWithSize-submit', function() {
            var url = $('.js-contactus-action').data('action');
            var form = $('#helpWithSize-form');
            var productID = $('#helpWithSizeContactSku').val();
            var checkHoneyPot = $('.contact_me_if_spam').val();
            var isSpam = checkHoneyPot.length > 0 ? true : false;
            if (!isSpam) {
                const readyToSubmit = $.Deferred();
                if (navigationCountry === 'CN') {
                    // initialize tencent captcha
                    var $tencentCaptchaEl = $('.js-tencent-captcha-container', form);
                    TencentCaptcha.initialize($tencentCaptchaEl, readyToSubmit);
                } else {
                    readyToSubmit.resolve();
                }

                readyToSubmit.done(function() {
                    form.spinner().start();
                    $.ajax({
                        url: url,
                        method: 'POST',
                        data: form.serialize(),
                        success: function (data) {
                            if (data.success) {
                                // analytics
                                dataLayer.push({
                                    event: 'contactUs',
                                    eventCategory: 'Contact Us - PDP',
                                    eventAction: 'submit_ok',
                                    eventLabel: 'product - size',
                                    dimension23: productID,
                                    dimension24: ''
                                });
                            } else {
                                dataLayer.push({
                                    event: 'contactUs',
                                    eventCategory: 'Contact Us - PDP',
                                    eventAction: 'submit_fail',
                                    eventLabel: 'product - size',
                                    dimension23: productID,
                                    dimension24: ''
                                });
                            }
                            form.spinner().stop();
                            updateSuccessPage($('#helpWithSize-form'), data);
                        },
                        error: function (data) {
                            form.spinner().stop();
                            updateSuccessPage($('#helpWithSize-form'), data.responseJSON);
                            dataLayer.push({
                                event: 'contactUs',
                                eventCategory: 'Contact Us - PDP',
                                eventAction: 'submit_fail',
                                eventLabel: 'product - size',
                                dimension23: productID,
                                dimension24: ''
                            });
                        }
                    });
                });
            }
        });
    }
};
